import React, { useEffect, useState } from 'react';
import { useCartStore } from 'src/hooks/cart';
import DisplayQtyMinQtyMult from 'src/component/custom/DisplayQtyMinQtyMult';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import useReduxState from 'src/hooks/useReduxState';
import Constants from 'src/helper/Constants';
import System from 'src/helper/system';

const QuantityPicker = (props) => {
    const { translation: t } = System;
    // Destructuring Props
    const { single_product, force_default_quantity, readOnly_quantity, CHECK_CART_RELATED_INVENTORY_VALIDATION, disable_increase_decrease,
        single_product_inventory, invalid_quantity_message_text = t('invalidQuantity') } = props;

    const [__check] = useAxiosIndicatorCheck();
    const uniqueId = props.qp_unique_id ? props.qp_unique_id : single_product.ItemNumber
    const { QuantityAction: { Minus, Plus } } = Constants;
    const [{ CART_DATA }, { backorder_not_available }, { SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT }] = useCartStore();
    const [QtyMult, setQtyMult] = useReduxState(single_product.QtyMult, 'single_product__QtyMult' + uniqueId);
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [QtyMin, setQtyMin] = useReduxState(single_product.QtyMin, 'single_product__QtyMin' + uniqueId);
    const [quantityVal, setQuantityVal] = useReduxState(QtyMin, 'single_product__QuantityVal' + uniqueId);
    const [quantityError, setQuantityError] = useState('');

    const isFromCart = System.isCallFromCart();

    const [addToCartSingleClick] = useReduxState({}, 'addToCartSingleClick')

    useEffect(() => {
        if (force_default_quantity) {
            setQuantityVal(force_default_quantity && force_default_quantity > 0 ? force_default_quantity : disable_increase_decrease ? '' : QtyMin)
        }
    }, [force_default_quantity]);

    useEffect(() => {
        async function fetchHere() {
            let isMinMultUpdate = false
            if (single_product) {
                const updatedProduct = { ...single_product, quantityUpdateToCart: quantityVal };
                await manageDispatch(updatedProduct);
                if (!isMinMultUpdate) {
                    validateQuantity(quantityVal)
                }
            }
        }
        fetchHere();
    }, [quantityVal]);

    useEffect(() => {
        validateQuantity(quantityVal)
    }, [CART_DATA[single_product.ItemNumber]?.quantity, CART_DATA[single_product.ItemNumber]?.backOrderedQuantity, single_product_inventory?.totalInventory, QtyMin, addToCartSingleClick]);

    // -----All useEffects over----- //

    const setQuantityWithAction = async (action) => {
        let qty = quantityVal;
        if (quantityVal === "" && firstServerCall) {
            qty = 0;
        }

        if (action === Minus) {
            qty = qty <= QtyMin ? QtyMin : (qty - QtyMult)
        } else {
            let productQty = single_product_inventory.totalInventory
            if (backorder_not_available(single_product) && qty > productQty && isFromCart) {
                System.popup('BackorderNotAvailable', { singleProduct: single_product })
            } else {
                qty = qty < QtyMin ? QtyMin : (qty + QtyMult)
            }
        }
        await manageTempQuantity(qty, 200)
    };

    const validateQuantity = (qty, isValidateClick = true) => {
        let res = ''
        if (qty >= 0 && qty !== "") {
            if (QtyMin < QtyMult && qty % QtyMin !== 0) {
                res = invalid_quantity_message_text;
            } else if (QtyMin && qty < QtyMin) {
                res = invalid_quantity_message_text;
            } else if (QtyMult && qty % QtyMult !== 0) {
                res = invalid_quantity_message_text;
            } else if (CHECK_CART_RELATED_INVENTORY_VALIDATION === true && single_product.ERPPartNumber) {
                let productQty = single_product_inventory?.totalInventory
                if ((CART_DATA[single_product.ItemNumber]?.quantity > productQty) && (CART_DATA[single_product.ItemNumber]?.backOrderedQuantity === 0 || (CART_DATA[single_product.ItemNumber].backOrderedQuantity !== (CART_DATA[single_product.ItemNumber].quantity - productQty)))) {
                    res = t('insufficientInventory')
                }
            }
        }

        const payload = {
            ...single_product,
            quantityUpdateToCart: qty,
            invalid_quantity: !!res,
        };
        SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT(payload)
        setQuantityError(res)
        return !!res
    };
    const manageTempQuantity = async (qty, timeOut = 700) => {
        setFirstServerCall(false)

        qty = parseInt(qty);

        if (isNaN(qty)) {
            qty = disable_increase_decrease ? '' : 0;
        }
        // if (!firstServerCall)
        setQuantityVal(qty)

        const delayDebounceFn = setTimeout(async () => {
            if (qty === false) return;

            if (props.disable_edit_force_default_quantity) { // cart quantitypicker, bomExactMatch, cartManuallyAddPart -- true

                if (props.getPlanInputQuantityCallback) {
                    props.getPlanInputQuantityCallback(qty) // bomExactMatch update quantity callback
                }
                if (props.getPlanInputQuantityValidatedCallback) {
                    props.getPlanInputQuantityValidatedCallback(qty)
                }
            }

        }, timeOut);


        return () => clearTimeout(delayDebounceFn)
    }

    const manageDispatch = async (single_product_here) => {
        SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT(single_product_here)
    };

    const getDisableStatus = () => {
        return !!(__check(['CART_OPERATION_API_CALL']).status || readOnly_quantity);
    };

    return (
        <>
            {single_product?.ItemNumber &&
                <>
                    <div className="quantity w-auto clearfix ">
                        <div className={quantityError ? "quantity-picker error" : "quantity-picker"}>
                            <div className="bs5 input-group flex-nowrap border-0">
                                {!disable_increase_decrease &&
                                    <span className="bs5 input-group-prepend flex-nowrap">
                                        <button
                                            disabled={getDisableStatus()}
                                            type="button"
                                            aria-label="Decrease Quantity"
                                            onClick={() => { setQuantityWithAction(Minus) }}
                                            className="bs5 btn btn-outline-secondary btn-number br-0"
                                        >
                                            <span className="fa fa-minus" />
                                        </button>
                                    </span>
                                }

                                <input
                                    type="text"
                                    disabled={getDisableStatus()}
                                    className="form-control form-control-sm"
                                    aria-labelledby="Quantity"
                                    // value={isEditEnable && firstServerCall && isFrom !== BOM && isFrom !== CART ? '' : quantityVal}
                                    value={quantityVal}
                                    onChange={async (e) => {
                                        await manageTempQuantity(e.target.value);
                                    }}

                                />
                                {!disable_increase_decrease &&
                                    <span className="bs5 input-group-append flex-nowrap">
                                        <button
                                            disabled={getDisableStatus()}
                                            type="button"
                                            aria-label="Increase Quantity"
                                            onClick={() => { setQuantityWithAction(Plus) }}
                                            className="bs5 btn btn-outline-secondary btn-number bl-0"
                                        >
                                            <span className="fa fa-plus" />
                                        </button>
                                    </span>
                                }
                            </div>

                            {/* manage validations */}
                            {quantityError && <span className="mandatory">{quantityError} </span>}

                        </div>
                    </div>
                    {props.showDisplayQtyMinQtyMult &&
                        <div className="text-start small-text light light-text collapse_minmax">
                            <DisplayQtyMinQtyMult single_product={single_product} />
                        </div>
                    }
                </>
            }
        </>
    );
}

export default QuantityPicker;